module.exports = __webpack_public_path__ + "img/logo2.e0583ce3.png";